module.exports = __webpack_public_path__ + "static/media/Poliana Afonso.91c7f077.jpg";